import { ADDTSTEMPLATE_SUCCESS, ADDTSTEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const addTsTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDTSTEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADDTSTEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addTsTemplateReducer;
